import { DocumentsSearch } from 'components/documents-search';
import { WorkspaceMap } from 'components/workspace-map';
import { getMapDefaultConfig } from 'components/map/atoms';
import { atomWithStorage } from 'jotai/utils';
import {
  TitleWorkspaceResponse,
  ReferenceLocationResponse,
} from 'types/api-responses';

const mapConfigAtom = atomWithStorage(
  'insights-workspace-document-index-map-config',
  getMapDefaultConfig()
);

const TitleWorkspaceDocumentIndexPage = ({
  titleWorkspace,
}: {
  titleWorkspace: TitleWorkspaceResponse;
}) => {
  return (
    <WorkspaceMap
      mapConfigAtom={mapConfigAtom}
      referenceLocationHref={titleWorkspace.referenceLocation.href}
    >
      {({
        referenceLocation,
      }: {
        referenceLocation: ReferenceLocationResponse;
      }) => (
        <DocumentsSearch
          noGutter
          showTips
          hideMap
          withinReferenceLocationId={referenceLocation.id}
          downloadHref={referenceLocation.resources?.documentsDownloads?.href}
        />
      )}
    </WorkspaceMap>
  );
};

export { TitleWorkspaceDocumentIndexPage };
